const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof gms_r4 !== "undefined") return resolve();
	__webpack_require__.l("/assets/gms-r4/remote.js", (event) => {
		if(typeof gms_r4 !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "gms_r4");
}).then(() => (gms_r4));